import {KeyValue} from '@angular/common';
import { ProductPricingV2 } from 'src/app/core/models/productv2/productpricingv2.model';
import { AbstractRenewalPricingItemInitializer } from '../abstract-renewal-pricing-item-initializer';
import { BillingLine } from 'src/app/core/models/billing-line/billing-line.model';
import { PricingItem } from 'src/app/core/models/quote/pricing-item/pricing-item';

export class DiscoPricingItemInitializer extends AbstractRenewalPricingItemInitializer {


    getPrefilledInputs(productPricings: ProductPricingV2[], referential: any, customerContract: BillingLine): Record<string, any> {
        return this.getCommonPrefilledInputs(productPricings, referential, customerContract);
    }

    initUserInputs(customerContract: BillingLine, prefilledInputs: any, pricingItem: PricingItem): Record<string, any> {
        const foundBillingMode = prefilledInputs.billingModes.find(item => item.key == customerContract.chargingType);
        const foundFrequency = prefilledInputs.frequencies.find(item => item.key == customerContract.serviceFrequency);

        if (customerContract.isConsumable) {
            return {
                billingMode: foundBillingMode || prefilledInputs.billingModes[0],
                frequency: foundFrequency || prefilledInputs.frequencies[0],
                consumableQuantity: customerContract.monthlyQuantity,
                franchiseConso: customerContract.getFranchiseConso(),
            };
        }

        return {
            billingMode: foundBillingMode || prefilledInputs.billingModes[0],
            frequency: foundFrequency || prefilledInputs.frequencies[0],
            quantity: customerContract.monthlyQuantity,
        };

    }

    sortFrequencies(referentialFrequencies: any, frequencies: KeyValue<string, string>[]) {
        const sortedFrequencies: KeyValue<string, string>[] = [];
        referentialFrequencies.forEach(referentialFrequency => {
            if (frequencies.some(frequency => frequency.key === referentialFrequency.frequency)) {
                sortedFrequencies.push({
                    key: referentialFrequency.frequency,
                    value: referentialFrequency.frequency
                });
            }
        });
        return sortedFrequencies;
    }
}
